import React from 'react';
import { Phone, MessageSquare, Calendar } from 'lucide-react';
import { contactData } from '../data/contactData';
import Button from './Button';

export default function CTASection({
  onOpenConsultation,
  title = "Taking the First Step Starts With a Conversation.",
  subtitle = null,
  primaryButtonText = "Book a Consultation"
}) {
  return (
    <section className="py-20 lg:py-28 bg-[#123B5D] text-white relative overflow-hidden">
      {/* Decorative gradient subtle light */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-[#0F766E]/30 via-[#123B5D] to-[#123B5D] pointer-events-none"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-normal text-white tracking-tight max-w-3xl mx-auto leading-[1.18]">
          {title}
        </h2>

        {subtitle && (
          <p className="mt-5 text-base sm:text-lg text-[#D9E8E5] max-w-2xl mx-auto leading-relaxed">
            {subtitle}
          </p>
        )}

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
          <Button
            onClick={onOpenConsultation}
            variant="primary"
            size="md"
            className="w-full sm:w-auto max-w-xs sm:max-w-none text-xs sm:text-base py-2.5 sm:py-3.5 px-4 sm:px-7 shadow-md"
          >
            <Calendar className="w-4 h-4 flex-shrink-0" />
            <span>{primaryButtonText}</span>
          </Button>

          <Button
            href={`tel:${contactData.phones[0].raw}`}
            variant="darkOutline"
            size="md"
            className="w-full sm:w-auto max-w-xs sm:max-w-none text-xs sm:text-base py-2.5 sm:py-3.5 px-4 sm:px-7"
          >
            <Phone className="w-4 h-4 flex-shrink-0" />
            <span>Call UMED: {contactData.phones[0].number}</span>
          </Button>

          <Button
            href={contactData.whatsapp.link}
            variant="secondary"
            size="md"
            className="w-full sm:w-auto max-w-xs sm:max-w-none text-xs sm:text-base py-2.5 sm:py-3.5 px-4 sm:px-7"
          >
            <MessageSquare className="w-4 h-4 flex-shrink-0" />
            <span>WhatsApp Care Desk</span>
          </Button>
        </div>
      </div>
    </section>
  );
}
